export const POST = 'posts_feed_post';
export const TOPIC_POST = 'posts_topic_post';
export const TRIP = 'trip';
export const EVENT = 'event';
export const CHECKIN = 'current';
export const VENTURE = 'ventures_venture';
export const OPPORTUNITY = 'business_opportunities_request';
